
























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({})
export default class RkPanel extends Vue {
  @Prop() private title!: string;
  @Prop({ default: '' }) private width!: string;
}
